import { IconCheck } from '@tabler/icons-react'
import { components, OptionProps } from 'react-select'

import { SizeOptions } from '../../../../types/types'
import { AstraIcon } from '../../../AstraIcon/AstraIcon'
import { AstraParagraph } from '../../../Typography/AstraParagraph/AstraParagraph'
import { astraTwMerge } from '../../../Utilities/astraTwMerge'
import { SelectOption, SelectOptionGroup } from '../types'
import { sizeStyles, typographyStyles } from '../utils/styles'

export const optionClassName = (size: SizeOptions) => (state: { isSelected: boolean; isFocused: boolean; isDisabled: boolean }) =>
    astraTwMerge(
        'relative !flex !cursor-pointer select-none items-center gap-2 !rounded-md !px-2 transition-colors',
        sizeStyles[size],
        state.isSelected ? '!bg-neutral-subtle-selected hover:!bg-neutral-subtle-selected' : '',
        state.isFocused && !state.isSelected ? '!bg-surface-muted' : '',
        state.isDisabled ? '!cursor-not-allowed !text-disabled' : ''
    )

export function CustomOption<T>(props: OptionProps<SelectOption<T>, false, SelectOptionGroup<T>> & { size: SizeOptions; hasCheckbox: boolean }) {
    const { data, size, hasCheckbox } = props
    const innerProps = { ...props.innerProps, 'data-test': `${data.label}-option` } as typeof props.innerProps
    return (
        <components.Option {...props} innerProps={innerProps}>
            {data.icon && <span className="flex shrink-0 items-center">{data.icon}</span>}
            <AstraParagraph variant={typographyStyles[size]} weight="regular" className="truncate text-inherit">
                {data.label}
            </AstraParagraph>
            {hasCheckbox && props.isSelected && (
                <span className="absolute right-0 inline-flex w-6 items-center justify-center">
                    <AstraIcon icon={IconCheck} />
                </span>
            )}
        </components.Option>
    )
}
